module.exports = __webpack_public_path__ + "img/icon-hamburger.40a96c95.svg";